"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Retrieve whether the given value is present. The keyword true is the only
 * value which is considered present.
 *
 * @Param {boolean} bool - The value to check.
 *
 * @Example
 *
 *   isPresent(true)
 *   //=> true
 *
 *   isPresent(false)
 *   //=> false
 */
function isPresent(bool) {
    return bool === true;
}
exports.isPresent = isPresent;
//# sourceMappingURL=is-present.js.map